var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficeAvatar6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0456,
    cy: 35.0454,
    r: 33.3766,
    fill: "#DFEBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1329 13.5144C40.7279 13.5144 47.7247 9.26557 50.521 16.3453C51.8792 19.7821 50.2958 26.8866 47.3349 33.2884C47.5794 35.4264 47.7223 37.8525 47.7223 40.4202C47.7223 49.0246 46.1583 56 44.2239 56C39.1082 56 43.8728 37.5893 35.1304 37.5893C26.3881 37.5893 31.0365 56 26.037 56C24.105 56 22.541 49.0246 22.541 40.4202C22.541 37.8525 22.6815 35.4264 22.9284 33.2884C19.9699 26.8866 18.3841 19.7821 19.7399 16.3453C22.5386 9.26557 29.533 13.5144 35.128 13.5144H35.1329Z",
    fill: "#307F92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAvatar6);
export default __webpack_public_path__ + "static/media/Office-Avatar-6.86f0105fd1578a7dea2a1401076b66ce.svg";
export { ForwardRef as ReactComponent };